import { indexBy, omit } from 'remeda';

import { type Article, type RevisionData } from '@@api/services/content/schemas/article';
import { DEFAULT_TENANT_ID } from '@@containers/metadata/constants';
import { ELEMENT_TYPES } from '@@plate/serialization/unity/constants';
import { type RootElement } from '@@plate/serialization/unity/groups';

import { findInContent } from './deserialization';

export const transformToArticleContent = (entity: Article | RevisionData): RootElement[] => {
    // This is required because of Conflict Resolution which already has title, title header and lead inside its content
    if (findInContent(entity.content, ELEMENT_TYPES.TITLE_HEADER)) {
        return entity.content;
    }

    // First we transform the variants to match the BE format
    const variantsByKey = indexBy(entity.variants, (variant) => variant.variantId);

    // Issue #4120
    // oxlint-disable-next-line typescript/no-explicit-any
    let headings: any[] = [];

    Object.entries(variantsByKey).forEach(([variantId, variant]) => {
        headings = variant.headings.map((element, elementIndex) => ({
            ...(headings?.[elementIndex] || {}),
            // We need to convert the variantId back to number because the
            // indexBy util is creating string keys
            ...(Number(variantId) === DEFAULT_TENANT_ID
                ? // Variant data is rebuilt from the keyed entries below, so the default
                  // heading must not carry its own `variants` (it would re-add removed variants)
                  omit(element, ['variants'])
                : {
                      variants: {
                          ...headings?.[elementIndex]?.variants,
                          [variantId]: element,
                      },
                  }),
        }));
    });

    return headings.concat(entity.content);
};
